import { AiTaggingStep, AiTaggingType, AiThreshold, AiThresholdMarks, DataScopeField, SmartLabelStatus, AiModel, } from './enums';
export const THRESHOLD_MARKS_MAP = {
    0: AiThresholdMarks.LOW,
    50: AiThresholdMarks.MEDIUM,
    100: AiThresholdMarks.HIGH,
};
export const DEFAULT_FIELD_DETAIL = {
    currentField: null,
    selectedNodeList: null,
    taggingType: AiTaggingType.SINGLE,
    threshold: AiThreshold.MEDIUM,
};
export const LOADING_STEP_MAP = {
    [SmartLabelStatus.IN_PREPARE_DATA]: [SmartLabelStatus.IN_PREPARE_DATA],
    [SmartLabelStatus.READY_PREPARE_DATA]: [SmartLabelStatus.IN_PREPARE_DATA],
    [SmartLabelStatus.IN_TRAINING]: [SmartLabelStatus.IN_TRAINING],
    [SmartLabelStatus.READY_TO_LABEL]: [SmartLabelStatus.IN_LABEL],
    [SmartLabelStatus.IN_LABEL]: [SmartLabelStatus.IN_LABEL],
    [SmartLabelStatus.IN_SAVING_RESULT]: [SmartLabelStatus.IN_LABEL],
    [SmartLabelStatus.FINISH_LABEL]: [SmartLabelStatus.IN_LABEL],
    [SmartLabelStatus.LABEL_CANCELING]: [SmartLabelStatus.LABEL_CANCELING],
    [SmartLabelStatus.LABEL_CANCELED]: [SmartLabelStatus.LABEL_CANCELED],
};
/**
 * AI 标引max版的步骤
 */
export const AI_TAGGING_MAX_STEPS = [
    AiTaggingStep.SELECT_FIELD,
    AiTaggingStep.TAGGING_SETTING,
    AiTaggingStep.TAGGING_PROCESS,
    AiTaggingStep.TAGGING_RESULT,
];
export const PROCESSING_STEP_MAP = [
    AiTaggingStep.TAGGING_PROCESS,
];
export const DATA_SCOPE_OPTIONS = [
    DataScopeField.TTL,
    DataScopeField.TECHNICAL_TITLE,
    DataScopeField.ABST,
    DataScopeField.CLMS,
    DataScopeField.DESC,
    DataScopeField.TECHNICAL_PROBLEM,
    DataScopeField.PATENT_INNO_SUMMARY,
    DataScopeField.EFFICIENCY_SENTENCE,
];
export const DEFAULT_DATA_SCOPE = [
    DataScopeField.TTL,
    DataScopeField.TECHNICAL_TITLE,
    DataScopeField.ABST,
    DataScopeField.CLMS,
    DataScopeField.DESC,
    DataScopeField.TECHNICAL_PROBLEM,
    DataScopeField.PATENT_INNO_SUMMARY,
    DataScopeField.EFFICIENCY_SENTENCE,
];
export const DISABLED_SCOPE_OPTIONS = [
    DataScopeField.ABST,
];
export const GPT_DATA_SCOPE_OPTIONS = [
    DataScopeField.TTL,
    DataScopeField.TECHNICAL_TITLE,
    DataScopeField.ABST,
    DataScopeField.CLMS,
    DataScopeField.DESC,
    DataScopeField.TECHNICAL_PROBLEM,
    DataScopeField.PATENT_INNO_SUMMARY,
    DataScopeField.EFFICIENCY_SENTENCE,
    DataScopeField.ABST_IMAGE,
];
export const GPT_DISABLED_SCOPE_OPTIONS = [
    DataScopeField.ABST,
];
export const GPT_DEFAULT_DATA_SCOPE = [...GPT_DATA_SCOPE_OPTIONS];
export const ML_NODE_LIMIT = 100;
// AI 标引默认按列表顺序截取的专利上限：用户未显式选择且总数超过此值时，进入面板时自动设为 RANGE 1..N
export const AI_TAGGING_DEFAULT_PATENT_LIMIT = 5000;
export const DEFAULT_TAGGING_SETTING = {
    taggingType: AiTaggingType.SINGLE,
    threshold: 50,
    dataScope: [...GPT_DEFAULT_DATA_SCOPE],
    aiModel: AiModel.PATSNAP_GPT,
};
export const DEFAULT_NODE_SUMMARY = {
    context: '',
};
export const AI_MODEL_LIMITS = {
    [AiModel.PATSNAP_ML]: 50000,
    [AiModel.PATSNAP_GPT]: 5000,
};
